import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ShoppingBasket, ClipboardCheck, Gift } from 'lucide-react';
const mainProduct = {
  badge: 'Protocolo Principal',
  title: 'El Protocolo GUT de 21 días',
  description: 'La guía maestra con los 3 módulos del protocolo: El Reset, Re-población y Estabilidad. Día a día, sin dudas, para recuperar tu vientre plano y tu ligereza digestiva.',
  value: '49€',
  icon: BookOpen
};
const bonuses = [{
  badge: 'BONUS 1',
  title: 'Lista de la Compra Inteligente',
  description: 'Sabrás exactamente qué comprar en el súper sin dudar: alimentos amigos de tu microbiota, marcas recomendadas y sustituciones rápidas.',
  icon: ShoppingBasket
}, {
  badge: 'BONUS 2',
  title: 'Guía de Seguimiento Diario',
  description: 'Mide tu progreso de hinchazón cada mañana. Un sistema simple para ver cómo evoluciona tu vientre y tu energía día a día.',
  icon: ClipboardCheck
}];
export function ProductStack() {
  return <section className="py-24 md:py-36 bg-cream-warm" data-id="element-201">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-202">
        <div className="text-center mb-14 md:mb-16 max-w-2xl mx-auto" data-id="element-203">
          <span className="inline-flex items-center gap-2 text-salvia font-semibold tracking-[0.25em] text-xs uppercase mb-5" data-id="element-204">
            <Gift className="w-4 h-4" strokeWidth={2.25} data-id="element-205" />
            <span data-id="element-206">Todo lo que recibes por 9,90€</span>
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest leading-[1.1]" data-id="element-207">
            El Protocolo GUT LABS{' '}
            <span className="italic font-normal text-forest/70" data-id="element-208">
              + 2 bonus que aceleran tus resultados
            </span>
          </h2>
        </div>

        {/* Main protocol card */}
        <motion.article initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl p-6 md:p-8 border border-salvia/30 shadow-sm flex flex-col md:flex-row md:items-center gap-5 md:gap-7 mb-10" data-id="element-209">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-salvia/20 flex items-center justify-center shrink-0" data-id="element-210">
            <mainProduct.icon className="w-7 h-7 md:w-9 md:h-9 text-forest" strokeWidth={1.75} data-id="element-211" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-212">
            <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-213">
              <span className="inline-flex items-center text-[10px] font-black tracking-[0.18em] uppercase px-2.5 py-1 rounded-full bg-forest text-white" data-id="element-214">
                {mainProduct.badge}
              </span>
              <span className="text-xs font-bold text-forest/40 tracking-tight" data-id="element-215">
                Valor {mainProduct.value}
              </span>
            </div>
            <h3 className="font-serif text-xl md:text-2xl font-semibold tracking-tight text-forest leading-[1.2] mb-2" data-id="element-216">
              {mainProduct.title}
            </h3>
            <p className="text-[15px] text-forest/70 leading-relaxed" data-id="element-217">
              {mainProduct.description}
            </p>
          </div>
        </motion.article>

        {/* BONUS BOX — destacada */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="relative bg-salvia/15 border-2 border-dashed border-salvia/60 rounded-3xl p-6 md:p-8" data-id="element-218">
          {/* Top ribbon */}
          <div className="flex justify-center -mt-10 md:-mt-12 mb-6" data-id="element-219">
            <span className="inline-flex items-center gap-2 bg-forest text-white text-[11px] md:text-xs font-black tracking-[0.18em] uppercase px-5 py-2.5 rounded-full shadow-lg shadow-forest/25" data-id="element-220">
              <Gift className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-221" />
              <span data-id="element-222">Incluidos GRATIS con tu acceso hoy</span>
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-223">
            {bonuses.map((bonus, i) => {
            const Icon = bonus.icon;
            return <article key={i} className="bg-white rounded-2xl p-5 md:p-6 border border-salvia/30 flex flex-col" data-id="element-224">
                  <div className="flex items-center gap-3 mb-4" data-id="element-225">
                    <span className="w-12 h-12 rounded-2xl bg-cream-warm flex items-center justify-center shrink-0" data-id="element-226">
                      <Icon className="w-6 h-6 text-forest" strokeWidth={1.75} data-id="element-227" />
                    </span>
                    <span className="inline-flex items-center text-[10px] font-black tracking-[0.18em] uppercase px-2.5 py-1 rounded-full bg-salvia text-white" data-id="element-228">
                      {bonus.badge}
                    </span>
                  </div>
                  <h4 className="font-serif text-lg md:text-xl font-semibold tracking-tight text-forest leading-[1.2] mb-2" data-id="element-229">
                    {bonus.title}
                  </h4>
                  <p className="text-[14px] text-forest/70 leading-relaxed" data-id="element-230">
                    {bonus.description}
                  </p>
                </article>;
          })}
          </div>
        </motion.div>

        {/* Total value recap */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 md:mt-12 bg-white border border-salvia/40 rounded-3xl px-6 py-7 md:px-10 md:py-8 text-center" data-id="element-231">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-salvia mb-3" data-id="element-232">
            Valor real del pack completo
          </p>
          <div className="flex items-baseline justify-center gap-3 md:gap-4 flex-wrap" data-id="element-233">
            <span className="text-2xl md:text-3xl text-forest/40 font-medium line-through" data-id="element-234">
              49,90€
            </span>
            <span className="text-forest/50 text-lg" data-id="element-235">→</span>
            <span className="font-serif text-5xl md:text-6xl font-bold text-forest tracking-tight" data-id="element-236">
              9,90€
            </span>
          </div>
          <p className="text-sm md:text-base text-forest/75 font-medium mt-4" data-id="element-237">
            Protocolo + Lista de la Compra + Guía de Seguimiento. Todo por el
            precio de dos cafés.
          </p>
        </motion.div>
      </div>
    </section>;
}